// extracted by mini-css-extract-plugin
export default {"Footer":"style_Footer__omsrL","socialWrap":"style_socialWrap__kKcsL","fade":"style_fade__pnUZQ","fade2":"style_fade2__Dyvxw"};